export const CHAT_CONSTANTS = {
    STATE_DEBOUNCE_MS: 10,
    SCROLL_THRESHOLD_PX: 70,
    SCROLL_DELAY_MS: 450,
    MAX_MESSAGE_LENGTH: 2048,
    SCROLL_INTERVAL_MS: 300,
    IDLE_TIMEOUT_MS: 15000,
    STREAM_COMPLETE_DELAY_MS: 100,
} as const;

export const ICON_SIZES = {
    BUTTON_SIZE: 32,
    SVG_SIZE: 18,
    CITATION_BUTTON_HEIGHT: 36,
} as const;
